import type { PreloadedQuery } from 'react-relay';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import QUERY, {
	type PageSwitcherWithQueryQuery,
} from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-common/src/common/ui/page-switcher/__generated__/PageSwitcherWithQueryQuery.graphql';

const RESOURCE_TYPE_NAV4_SIDEBAR_SETTINGS_PAGE_SWITCHER = 'NAV4_SIDEBAR_SETTINGS_PAGE_SWITCHER';

export const nav4SidebarSettingsPageSwitcherResource: RouteResource<
	PreloadedQuery<PageSwitcherWithQueryQuery>
> = createRelayResource<PageSwitcherWithQueryQuery>({
	type: RESOURCE_TYPE_NAV4_SIDEBAR_SETTINGS_PAGE_SWITCHER,
	getQuery: (_routerContext, { tenantContext: { cloudId } }) => ({
		parameters: QUERY,
		variables: { cloudId },
		options: { fetchPolicy: 'store-and-network' as const },
	}),
	skip: (_routerContext, { tenantContext }) =>
		!fg('enable_jsm_admin') || tenantContext == null || tenantContext.isAdmin === true,
	captureErrors: true,
	isCritical: true,
});
